<template>
  <div class="main-container">
    <div class="logo-container">
      <GallabLogo class="logo" />
    </div>

    <div class="step-indicator">
      <h1 class="title">WYBIERZ GRUPĘ</h1>
      <div class="steps">
        <div class="step active">
          <p>
            WYBÓR MATERIAŁU
          </p>
        </div>
        <div class="step">
          <p>
            WYBÓR MODELU
          </p>
        </div>
      </div>
    </div>

    <div v-if="!isLoading" class="material-cards-vertical">
      <div v-for="(material, index) in availableMaterials" :key="material" class="material-card-vertical"
        :class="`delay-${index}`" @click="selectMaterial(material)"
        :style="{ '--bg-image': `url(${materialImages[material]})` }">
        <h3 class="material-name">{{ materialToDisplayName(material) }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import { useTrailerStore } from '@/stores/trailerStore'
import steelImage from '@/assets/images/steel.webp'
import aluminiumImage from '@/assets/images/aluminium.webp'
import steelAndAluImage from '@/assets/images/steel-and-aluminium.webp'
import GallabLogo from '@/components/common/GallabLogo.vue'

export default {
  data() {
    return {
      trailerStore: null,
      isLoading: false
    }
  },
  components: {
    GallabLogo
  },
  async created() {
    this.trailerStore = useTrailerStore()
    if (this.availableMaterials.length === 1) {
      this.selectMaterial(this.availableMaterials[0])
    }
  },
  computed: {
    availableMaterials() {
      return Object.keys(this.trailerStore.trailersGrouped)
    },
    materialImages() {
      return {
        'Stal': steelImage,
        'Alu': aluminiumImage,
        'Stal/Alu': steelAndAluImage
      }
    }
  },
  methods: {
    materialToDisplayName(material) {
      return {
        'Stal': 'Laweta Stalowa',
        'Alu': 'Laweta Aluminiowa',
        'Stal/Alu': 'Laweta Stalowa / Aluminiowa'
      }[material] || material
    },
    selectMaterial(material) {
      this.trailerStore.selectedMaterial = material
      this.$router.push('/models')
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.logo-container {
  display: flex;
  justify-content: flex-start;
  align-items: start;
}

@media (max-width: 768px) {
  .logo-container {
    justify-content: center;
    align-items: center;
  }
}

.title {
  font-weight: 500;
  font-size: 1.5rem;
  color: $color-primary-dark;
}


.step-indicator {
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: default;
}

.steps {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.step {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 250px;
  margin-left: -5px;
  padding: 10px 20px;
  background: $color-primary-lighter;
  color: $color-text-light;
  font-weight: 500;
  clip-path: polygon(15px 50%,
      0 0,
      100% 0,
      100% 50%,
      100% 100%,
      0 100%,
      15px 50%);

  &.active {
    width: 350px;
    height: 60px;
    background: $color-primary;
    color: $color-white;
    clip-path: polygon(20px 50%,
        0 0,
        calc(100% - 20px) 0,
        100% 50%,
        calc(100% - 20px) 100%,
        0 100%,
        0 0);
  }

  @media (max-width: 678px) {
    width: 40%;
    height: 50px;
    font-size: 0.9rem;

    &.active {
      width: 60%;
      height: 55px;
      font-size: 1rem;
    }
  }
}

.material-cards-vertical {
  margin-top: 10px;
  margin-bottom: 150px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.material-card-vertical {
  position: relative;
  border: 2px solid $color-grey-light;
  border-radius: 12px;
  padding: 60px 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 200px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-white;

  background-image: linear-gradient(rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.2)), var(--bg-image);

  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);

  &:hover {
    border-color: $color-primary;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  }

  opacity: 0;
  animation: fadeInUp 0.6s ease forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.delay-0 {
  animation-delay: 0s;
}

.delay-1 {
  animation-delay: 0.3s;
}

.delay-2 {
  animation-delay: 0.4s;
}

.delay-3 {
  animation-delay: 0.5s;
}

.material-name {
  font-size: 1.5rem;
  text-transform: uppercase;
  margin: 0;
  color: $color-white;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 768px) {
  .title {
    font-size: 1.8rem;
  }

  .step-indicator {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .material-cards-vertical {
    max-width: 100%;
  }
}
</style>